export enum Impact {
	Bullet = 'impactBullet'
}
